import { render } from "./ContentWrapper.vue?vue&type=template&id=0e2f396c&scoped=true"
import script from "./ContentWrapper.vue?vue&type=script&lang=js"
export * from "./ContentWrapper.vue?vue&type=script&lang=js"

import "./ContentWrapper.vue?vue&type=style&index=0&id=0e2f396c&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2f396c"]])

export default __exports__